import { CreditCardIcon, UserCircleIcon } from "@heroicons/react/outline";
import CogIcon from "@heroicons/react/solid/CogIcon";
import cn from "classnames";
import React from "react";
import { matchPath, Switch, useLocation } from "react-router";
import { Link, Redirect, Route } from "react-router-dom";
import { useTitle } from "react-use";
import {
  ROUTE_SETTINGS_ACCOUNT,
  ROUTE_SETTINGS_CONTACT,
  ROUTE_SETTINGS_FINANCIAL,
} from "../../routes";
import Account from "./components/Account";
import Contact from "./components/Contact";
import Financial from "./components/Financial";

const subNavigation = [
  {
    name: "Contact Information",
    to: ROUTE_SETTINGS_CONTACT,
    icon: UserCircleIcon,
  },
  {
    name: "Account",
    to: ROUTE_SETTINGS_ACCOUNT,
    icon: CogIcon,
  },
  {
    name: "Financials",
    to: ROUTE_SETTINGS_FINANCIAL,
    icon: CreditCardIcon,
  },
  // { name: "Password", href: "#", icon: KeyIcon, current: false },
  // { name: "Notifications", href: "#", icon: BellIcon, current: false },
  // { name: "Integrations", href: "#", icon: ViewGridAddIcon, current: false },
];

const Settings = () => {
  useTitle("Settings | Due");
  const location = useLocation();

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className="divide-y divide-gray-200 lg:grid lg:grid-cols-12 lg:divide-y-0 lg:divide-x">
        <aside className="py-6 lg:col-span-3">
          <nav className="space-y-1">
            <h1 className="ml-4 mb-4 text-2xl font-semibold">Settings</h1>
            {subNavigation.map(({ to, name, icon: LinkIcon }) => (
              <Link
                key={name}
                to={to}
                className={cn(
                  matchPath(location.pathname, to)
                    ? "bg-emerald-50 border-emerald-500 text-emerald-700 hover:bg-emerald-50 hover:text-emerald-700"
                    : "border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900",
                  "group border-l-4 px-3 py-2 flex items-center text-sm font-medium"
                )}
                aria-current={
                  matchPath(location.pathname, to) ? "page" : undefined
                }
              >
                <LinkIcon
                  className={cn(
                    matchPath(location.pathname, to)
                      ? "text-emerald-500 group-hover:text-emerald-500"
                      : "text-gray-400 group-hover:text-gray-500",
                    "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                  )}
                  aria-hidden="true"
                />
                <span className="truncate">{name}</span>
              </Link>
            ))}
          </nav>
        </aside>
        <section className="divide-y divide-gray-200 divide-y divide-gray-200 lg:col-span-9">
          <Switch>
            <Route path={ROUTE_SETTINGS_ACCOUNT}>
              <Account />
            </Route>
            <Route path={ROUTE_SETTINGS_CONTACT}>
              <Contact />
            </Route>
            <Route path={ROUTE_SETTINGS_FINANCIAL}>
              <Financial />
            </Route>
            <Redirect to={ROUTE_SETTINGS_CONTACT} />
          </Switch>
        </section>
      </div>
    </div>
  );
};

export default Settings;
